import React, { useEffect, useState } from "react";

import classes from "./TaskRequestDetail.module.scss";

import messages from "./module/messages";

import { goBack } from "connected-react-router";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserInfo } from "../../../App/module/selectors";
import {
  ISectionType,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";
import CommentModal from "../../../components/Modals/CommentModal/CommentModal";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import CustomModal from "../../../components/Modals/CustomModal/CustomModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import PageSpinner from "../../../components/PageSpinner";
import Table from "../../../components/Table/Table";
import TaskOperationFixedField from "../../../components/TaskOperationFixedField/TaskOperationFixedFiled";
import TaskOperationRemoteField from "../../../components/TaskOperationRemoteField/TaskOperationRemoteField";
import {
  ITargetAttribute,
  ITaskAcceptRequestBody,
  ITaskAccountBody,
  ITaskDetailRequestBody,
  ITaskFixedAttributes,
  ITaskOperationSnapshot,
  ITaskRequestDetail,
  TaskActionType,
  TaskOperationType,
} from "../../../models/Task";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import Panel from "../../../ui/Panel/Panel";
import TextDetail from "../../../ui/TextDetail/TextDetail";
import {
  approveCommentTaskRequest,
  approveTaskRequest,
  cancelTakeChargeRequest,
  fetchTaskDetail,
  rejectCommentTaskRequest,
  rejectTaskRequest,
  resetTaskDetail,
  takeChargeRequest,
} from "../module/actions";
import {
  selectedTask,
  selectTaskDetail,
  selectTaskDetailLoader,
  selectTaskMainCallState,
  selectTaskMainCallStateTakeCharge,
} from "../module/selector";
import { IAggregateTask } from "./module/constants";
import {
  createRequestDetailFieldList,
  generateAcceptTaskChangedList,
} from "./module/utils";

const TaskRequestDetail = (props: ITaskRequestDetail) => {
  const [comment, setComment] = useState("");
  const [confirmModalIsVisible, setConfirmModalIsVisible] = useState(false);
  const [responseModalIsVisible, setResponseModalIsVisible] = useState(false);
  const [commentModalIsVisible, setCommentModalIsVisible] = useState(false);
  const [actionType, setActionType] = useState("");
  const [acceptRequestBody, setAcceptRequestBody] =
    useState<ITaskAcceptRequestBody[]>();
  const [revokeRequestBody, setRevokeRequestBody] = useState<string[]>();
  const [attributeTask, setAttributeTask] = useState<ITaskOperationSnapshot[]>(
    []
  );
  const [aggregateTask, setAggregateTask] = useState<IAggregateTask[]>([]);
  const [plainTask, setPlainTask] = useState<ITaskOperationSnapshot[]>([]);
  const [acceptOpChangedList, setAcceptOpChangedList] = useState<
    ITaskAcceptRequestBody[]
  >([]);
  const [emptySelctedTaskModalIsVisible, setEmptySelctedTaskModalIsVisible] =
    useState<boolean>(false);
  const [executedTaskId, setExecutedTaskId] = useState("");
  const [executedTaskIds, setExecutedTaskIds] = useState<string[]>([]);
  let selectedAggregateTask: IAggregateTask[] = [];

  const {
    selectedTask,
    taskDetail,
    mainCallState,
    taskLoader,
    fetchTaskDetail,
    execute,
    reject,
    executeWithComment,
    rejectWithComment,
    goBack,
  } = props;

  useEffect(() => {
    fetchTaskDetail({
      parentId: selectedTask.parentId,
      userId: selectedTask.beneficiary_id,
      application: selectedTask.application,
    });
  }, []);

  useEffect(() => {
    if (acceptOpChangedList && acceptOpChangedList.length === 0) {
      setAcceptOpChangedList(generateAcceptTaskChangedList(taskDetail)!);
    }

    if (taskDetail && taskDetail.taskDetails.length > 0) {
      const tempAttributetasks = [
        ...taskDetail.taskDetails.filter((task) => task.details),
      ];
      setAttributeTask(tempAttributetasks);

      const tempAggregateTasks: IAggregateTask[] = [
        ...taskDetail.taskDetails.filter(
          (task) =>
            !task.details && (task.action === "1" || task.action === "2")
        ),
      ].map((task, index) => {
        const tempAggTask: IAggregateTask = {
          actionCode: task.action + "",
          task_id: task.task_id,
          entitlement: task.provisioning,
          entitlementDescription: task.description,
          account: task.account_id,
          operationExecuted: task.operationExecuted!,
          user_code:
            task.enrichment &&
            task.enrichment.inChargeOf &&
            task.enrichment.inChargeOf.code
              ? task.enrichment.inChargeOf.code
              : undefined,
        };
        return tempAggTask;
      });
      setAggregateTask(tempAggregateTasks);

      const tempPlainTasks = [
        ...taskDetail.taskDetails.filter(
          (task) => !task.details && task.action !== "1" && task.action !== "2"
        ),
      ];
      setPlainTask(tempPlainTasks);
    }
  }, [taskDetail, setAggregateTask, setAcceptOpChangedList, setAttributeTask]);

  const cancelModalHandler = () => {
    setConfirmModalIsVisible(false);
  };

  const confirmModalHandler = () => {
    setConfirmModalIsVisible(false);
    if (actionType === TaskOperationType.EXECUTE) {
      if (comment && comment.length > 0) {
        const reqBody = { body: acceptRequestBody, comment };
        executeWithComment(reqBody);
      } else {
        execute(acceptRequestBody!);
      }
    } else {
      if (comment && comment.length > 0) {
        const reqBody = { body: revokeRequestBody, comment };
        rejectWithComment(reqBody);
      } else {
        reject(revokeRequestBody!);
      }
    }
    setResponseModalIsVisible(true);
    setAttributeTask((tasks) =>
      tasks.map((task) => {
        if (task.task_id === executedTaskId) {
          task.operationExecuted = true;
        }
        return task;
      })
    );
    setPlainTask((tasks) =>
      tasks.map((task) => {
        if (task.task_id === executedTaskId) {
          task.operationExecuted = true;
        }
        return task;
      })
    );
    setAggregateTask((tasks) =>
      tasks.map((task) => {
        if (executedTaskIds && executedTaskIds.length > 0) {
          executedTaskIds.forEach((id) => {
            if (task.task_id === id) {
              task.operationExecuted = true;
            }
          });
        }
        return task;
      })
    );
  };

  const unexecuteHandler = (taskId: string) => {
    setRevokeRequestBody([taskId]);
    setActionType(TaskOperationType.UNEXECUTE);
    setCommentModalIsVisible(true);
    setExecutedTaskId(taskId);
  };

  const executeHandler = (taskId: string) => {
    const opToBeExecute = acceptOpChangedList.filter(
      (op) => op.taskId === taskId
    );
    if (opToBeExecute && opToBeExecute.length > 0) {
      setAcceptRequestBody(opToBeExecute);
    } else {
      const plainReqAcceptBody: ITaskAcceptRequestBody[] = [
        {
          taskId,
        },
      ];
      setAcceptRequestBody(plainReqAcceptBody);
    }
    setExecutedTaskId(taskId);

    setActionType(TaskOperationType.EXECUTE);
    setCommentModalIsVisible(true);
  };

  const onCloseResponseModal = () => {
    setAcceptOpChangedList([]);
    setExecutedTaskId("");
    setExecutedTaskIds([]);
    setResponseModalIsVisible(false);
  };

  const fixedOperationChangedHandler = (
    taskId: string,
    newValue: string,
    field: string
  ) => {
    const mappedField = field.split("@fixed_")[1];
    acceptOpChangedList.forEach((op) => {
      if (op.taskId === taskId && op.account) {
        op.account[mappedField as keyof ITaskAccountBody] = newValue;
      }
    });
  };

  const remoteOperationChangedHandler = (
    taskId: string,
    newValue: string,
    field: string
  ) => {
    const mappedField = field.split("@remote_")[1];
    acceptOpChangedList.forEach((op) => {
      if (op.taskId === taskId && op.account) {
        if (
          op.account.targetAttributes &&
          op.account.targetAttributes.length > 0 &&
          op.account.targetAttributes.filter(
            (remoteOp) => remoteOp.accountCfgAttrKey_name === mappedField
          ).length > 0
        ) {
          const index = op.account.targetAttributes.findIndex(
            (remoteOp: ITargetAttribute) =>
              remoteOp.accountCfgAttrKey_name === mappedField
          );
          if (index !== -1) {
            op.account.targetAttributes[index] = {
              value: newValue,
              accountCfgAttrKey_name: mappedField,
            };
          }
        } else {
          op.account.targetAttributes?.push({
            value: newValue,
            accountCfgAttrKey_name: mappedField,
          });
        }
      }
    });
  };

  const taskTableCheckboxChange = (selected: any[]) => {
    if (selected) {
      selectedAggregateTask = selected.map((item) => item.values);
    }
  };

  const executeFromTableHandler = () => {
    if (selectedAggregateTask.length > 0) {
      const tempAcceptReqList: ITaskAcceptRequestBody[] = [];
      selectedAggregateTask.forEach((task) => {
        const tempAcceptReqItem: ITaskAcceptRequestBody = {
          taskId: task.task_id,
        };
        tempAcceptReqList.push(tempAcceptReqItem);
      });
      setAcceptRequestBody(tempAcceptReqList);
      setActionType(TaskOperationType.EXECUTE);
      setCommentModalIsVisible(true);
      setExecutedTaskIds(selectedAggregateTask.map((task) => task.task_id));
    } else {
      setEmptySelctedTaskModalIsVisible(true);
    }
  };

  const unexecuteFromTableHandler = () => {
    if (selectedAggregateTask.length > 0) {
      const ids: string[] = selectedAggregateTask.map((task) => task.task_id);
      setRevokeRequestBody(ids);
      setActionType(TaskOperationType.UNEXECUTE);
      setCommentModalIsVisible(true);
      setExecutedTaskIds(selectedAggregateTask.map((task) => task.task_id));
    } else {
      setEmptySelctedTaskModalIsVisible(true);
    }
  };

  const onBackBtnClick = () => {
    goBack();
  };

  const closeEmptySelectedTaskModalHandler = () => {
    setEmptySelctedTaskModalIsVisible(false);
  };

  const confirmCommentModalHandler = (comment: string) => {
    setCommentModalIsVisible(false);
    setComment(comment);
    setConfirmModalIsVisible(true);
  };

  const cancelCommentModalHandler = () => {
    setCommentModalIsVisible(false);
  };

  if (taskLoader) {
    return <PageSpinner />;
  }

  return (
    <div className={classes["task-request-detail-wrapper"]}>
      <div>
        <OutlinedButton onClick={onBackBtnClick}>
          <FormattedMessage {...messages.back} />
        </OutlinedButton>
      </div>
      <Panel title={<FormattedMessage {...messages.requestDetail} />}>
        <TextDetail
          limit={3}
          fieldList={createRequestDetailFieldList(selectedTask)}
        />
      </Panel>
      {selectedTask.comment && (
        <Panel title={<FormattedMessage {...messages.comment} />}>
          <textarea className={classes["comment-textarea"]} disabled>
            {selectedTask.comment}
          </textarea>
          <div className={classes["comment-length-container"]}>
            {selectedTask.comment.length}/4000
          </div>
        </Panel>
      )}
      {taskDetail && taskDetail.taskDetails.length > 0 && (
        <div className={classes["operations-wrapper"]}>
          {attributeTask.map((task: ITaskOperationSnapshot) => {
            if (!task.operationExecuted) {
              return (
                <Panel
                  key={`${task.task_id}-${Math.random()}`}
                  title={
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <strong style={{ fontFamily: "mb" }}>
                            <FormattedMessage {...messages.requestLabel} />{" "}
                            <FormattedMessage
                              {...messages[
                                `${
                                  TaskActionType[
                                    task.action
                                  ] as keyof typeof TaskActionType
                                }` as keyof typeof messages
                              ]}
                            />
                          </strong>
                        </div>
                      </div>
                    </>
                  }
                >
                  {task.details && task.details.fixedAttributes && (
                    <Panel fullColored={true}>
                      <div className={classes["attributes"]}>
                        {Object.keys(task.details.fixedAttributes).map(
                          (key: string) => {
                            if (
                              task.details.fixedAttributes[
                                key as keyof ITaskFixedAttributes
                              ].newValue
                            ) {
                              if (
                                !(
                                  key === "@fixed_last_pwd_change" ||
                                  key === "@fixed_last_wrong_login" ||
                                  key === "@fixed_number_login_error"
                                )
                              ) {
                                return (
                                  <React.Fragment
                                    key={`${
                                      task.task_id + key
                                    }-${Math.random()}`}
                                  >
                                    <TaskOperationFixedField
                                      taskId={task.task_id}
                                      label={key}
                                      attribute={
                                        task.details.fixedAttributes[
                                          key as keyof ITaskFixedAttributes
                                        ]
                                      }
                                      onChangeValue={(
                                        newValue: string,
                                        label: string
                                      ) =>
                                        fixedOperationChangedHandler(
                                          task.task_id,
                                          newValue,
                                          label
                                        )
                                      }
                                    />
                                  </React.Fragment>
                                );
                              } else {
                                return <></>;
                              }
                            } else {
                              return <></>;
                            }
                          }
                        )}
                      </div>
                    </Panel>
                  )}

                  {task.details && task.details.remoteAttributes && (
                    <>
                      <br />
                      <Panel fullColored={true}>
                        <div className={classes["attributes"]}>
                          {Object.keys(task.details.remoteAttributes).map(
                            (key: string) => {
                              return (
                                <React.Fragment
                                  key={`${task.task_id + key}-${Math.random()}`}
                                >
                                  <TaskOperationRemoteField
                                    label={key}
                                    attribute={
                                      task.details.remoteAttributes[key][0]
                                    }
                                    onChangeValue={(
                                      newValue: string | undefined,
                                      label: string
                                    ) =>
                                      remoteOperationChangedHandler(
                                        task.task_id,
                                        newValue!,
                                        label
                                      )
                                    }
                                  />
                                </React.Fragment>
                              );
                            }
                          )}
                        </div>
                      </Panel>
                    </>
                  )}
                  <br />
                  <div className={classes.actions}>
                    <OutlinedButton
                      onClick={() => executeHandler(task.task_id)}
                    >
                      <FormattedMessage {...messages.execute} />
                    </OutlinedButton>
                    <OutlinedButton
                      onClick={() => unexecuteHandler(task.task_id)}
                    >
                      <FormattedMessage {...messages.unexecute} />
                    </OutlinedButton>
                  </div>
                </Panel>
              );
            } else {
              return <></>;
            }
          })}
          {aggregateTask &&
            aggregateTask.length > 0 &&
            aggregateTask.filter((task) => !task.operationExecuted).length >
              0 && (
              <div className={classes.aggregateContainer}>
                {aggregateTask.filter((task) => task.actionCode === "1")
                  .length > 0 && (
                  <Panel
                    title={
                      <>
                        <FormattedMessage {...messages.requestLabel} />{" "}
                        <FormattedMessage
                          {...messages[
                            `${
                              TaskActionType[
                                Number(
                                  aggregateTask.filter(
                                    (task) => task.actionCode === "1"
                                  )[0].actionCode
                                )
                              ] as keyof typeof TaskActionType
                            }` as keyof typeof messages
                          ]}
                        />
                      </>
                    }
                  >
                    <Table
                      dataSource={aggregateTask
                        .filter((task) => !task.operationExecuted)
                        .filter((task) => task.actionCode === "1")}
                      rowsChangeable={true}
                      showChekbox={true}
                      selectAll={true}
                      onCheckboxChangeEvent={true}
                      onCheckboxChange={taskTableCheckboxChange}
                      sectionType={ISectionType.TASKS}
                      tableType={ITableType.ENTITLEMENTS_TABLE}
                    />
                    <br />
                    <div className={classes.actions}>
                      <OutlinedButton onClick={executeFromTableHandler}>
                        <FormattedMessage {...messages.execute} />
                      </OutlinedButton>
                      <OutlinedButton onClick={unexecuteFromTableHandler}>
                        <FormattedMessage {...messages.unexecute} />
                      </OutlinedButton>
                    </div>
                  </Panel>
                )}
                {aggregateTask.filter((task) => task.actionCode === "2")
                  .length > 0 && (
                  <Panel
                    title={
                      <>
                        <FormattedMessage {...messages.requestLabel} />{" "}
                        <FormattedMessage
                          {...messages[
                            `${
                              TaskActionType[
                                Number(
                                  aggregateTask.filter(
                                    (task) => task.actionCode === "2"
                                  )[0].actionCode
                                )
                              ] as keyof typeof TaskActionType
                            }` as keyof typeof messages
                          ]}
                        />
                      </>
                    }
                  >
                    <Table
                      dataSource={aggregateTask
                        .filter((task) => !task.operationExecuted)
                        .filter((task) => task.actionCode === "2")}
                      rowsChangeable={true}
                      showChekbox={true}
                      selectAll={true}
                      onCheckboxChangeEvent={true}
                      onCheckboxChange={taskTableCheckboxChange}
                      sectionType={ISectionType.TASKS}
                      tableType={ITableType.ENTITLEMENTS_TABLE}
                    />
                    <br />
                    <div className={classes.actions}>
                      <OutlinedButton onClick={executeFromTableHandler}>
                        <FormattedMessage {...messages.execute} />
                      </OutlinedButton>
                      <OutlinedButton onClick={unexecuteFromTableHandler}>
                        <FormattedMessage {...messages.unexecute} />
                      </OutlinedButton>
                    </div>
                  </Panel>
                )}
              </div>
            )}
          {plainTask &&
            plainTask.length > 0 &&
            plainTask.map((task) => {
              if (!task.operationExecuted) {
                return (
                  <Panel
                    key={`${task.task_id}-${Math.random()}`}
                    title={
                      <>
                        <FormattedMessage {...messages.requestLabel} />{" "}
                        <FormattedMessage
                          {...messages[
                            `${
                              TaskActionType[
                                task.action
                              ] as keyof typeof TaskActionType
                            }` as keyof typeof messages
                          ]}
                        />
                      </>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "1rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          columnGap: "1rem",
                        }}
                      >
                        {(task.action === "1" || task.action === "2") && (
                          <FormattedMessage {...messages.entitlementLabel} />
                        )}
                        {task.action !== "1" && task.action !== "2" && (
                          <FormattedMessage {...messages.userIdLabel} />
                        )}
                        <span style={{ fontWeight: "bold" }}>
                          {task.provisioning ? task.provisioning : ""}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          columnGap: "1rem",
                        }}
                      >
                        <FormattedMessage
                          {...messages.entitlementDescriptionLabel}
                        />
                        <span style={{ fontWeight: "bold" }}>
                          {task.description ? task.description : ""}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          columnGap: "1rem",
                        }}
                      >
                        <FormattedMessage {...messages.applicationLabel} />
                        <span style={{ fontWeight: "bold" }}>
                          {task.application ? task.application : ""}
                        </span>
                      </div>
                    </div>
                    <div className={classes.actions}>
                      <OutlinedButton
                        onClick={() => executeHandler(task.task_id)}
                      >
                        <FormattedMessage {...messages.execute} />
                      </OutlinedButton>
                      <OutlinedButton
                        onClick={() => unexecuteHandler(task.task_id)}
                      >
                        <FormattedMessage {...messages.unexecute} />
                      </OutlinedButton>
                    </div>
                  </Panel>
                );
              } else {
                return <></>;
              }
            })}
        </div>
      )}

      <CustomModal
        show={emptySelctedTaskModalIsVisible}
        title={<FormattedMessage {...messages.emptyModalTitle} />}
        message={<FormattedMessage {...messages.emptyModalMessage} />}
        size="sm"
        onClose={closeEmptySelectedTaskModalHandler}
      />

      <CommentModal
        show={commentModalIsVisible}
        onCancel={cancelCommentModalHandler}
        onConfirm={confirmCommentModalHandler}
      />
      <ConfirmModal
        show={confirmModalIsVisible}
        onCancel={cancelModalHandler}
        onConfirm={confirmModalHandler}
      />
      <ResponseModal
        show={responseModalIsVisible}
        state={mainCallState}
        onClose={onCloseResponseModal}
      />
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    selectedTask,
    taskDetail: selectTaskDetail,
    mainCallState: selectTaskMainCallState,
    taskLoader: selectTaskDetailLoader,
    takeChargeCallState: selectTaskMainCallStateTakeCharge,
    userInfo: selectUserInfo,
  });

const mapDispatchToProps: any = {
  fetchTaskDetail: (body: ITaskDetailRequestBody) => fetchTaskDetail(body),
  execute: (body: ITaskAcceptRequestBody[]) => approveTaskRequest(body),
  reject: (body: string[]) => rejectTaskRequest(body),
  executeWithComment: (req: {
    body: ITaskAcceptRequestBody[];
    comment: string;
  }) => approveCommentTaskRequest(req),
  rejectWithComment: (req: { body: string[]; comment: string }) =>
    rejectCommentTaskRequest(req),
  goBack: () => goBack(),
  resetTaskDetail,
  takeChargeRequest,
  cancelTakeChargeRequest,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(TaskRequestDetail);
